module.exports = __webpack_public_path__ + "static/media/enterprise-square.bb8a144a.jpg";